import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/app/service/[slug]/page.tsx");
